/**
 * @Description 益禾堂美团竞品均值
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132274569
 */

import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import { setComValue } from '../../config';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';

interface EstimateSalesMTMeanProps {
  propertyItem: any;
  required: boolean;
  disabled: boolean;
}

const EstimateSalesMTMean: FC<EstimateSalesMTMeanProps> = ({
  propertyItem,
  required,
  disabled,
}) => {
  const methods = useMethods({
    handleNumInputChange: (val: number) => {
      setComValue(propertyItem, val);
    }
  });
  return (
    <V2FormInputNumber
      label={propertyItem?.anotherName || propertyItem?.name}
      name={propertyItem?.identification}
      placeholder='输入内容'
      max={999999999}
      required={required}
      disabled={disabled}
      config={{
        addonAfter: '元'
      }}
      onChange={(val: any) => methods.handleNumInputChange(val)}
    />
  );
};

export default EstimateSalesMTMean;
